import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/verify-2fa/')({});
